import {useNavigate} from 'react-router-dom';
import {OnboardingLayout} from './OnboardingLayout';
import {Button} from '@/components';
import {trackOnboardingStarted} from '@/services/analytics';
import styles from './Onboarding.module.css';

export function Welcome() {
  const navigate = useNavigate();

  function handleGetStarted() {
    trackOnboardingStarted();
    navigate('/departments');
  }

  return (
    <OnboardingLayout currentStep={1} totalSteps={4}>
      <h2 className={styles.stepTitle}>Welcome to Closai</h2>
      <p className={styles.stepDescription}>
        We'll import your purchases automatically from email. Everything you've
        bought from the past 5 years — instantly.
      </p>
      <Button onClick={handleGetStarted}>Get Started</Button>
      <button
        className={styles.loginLink}
        onClick={() => navigate('/connect-email', { state: { from: 'login' } })}
      >
        Already have an account? <span className={styles.loginLinkAccent}>Login here</span>
      </button>
    </OnboardingLayout>
  );
}
